
  import { Vue, Component, Prop } from "vue-property-decorator";

  import LinkIcon from "@/components/icons/LinkIcon.vue";
  import UIButton from "@/components/button/ui-button.vue";

  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";
  import RouteNames from "@/entities/RouteNames";
  import RouteParams from "@/entities/RouteParams";
  import { copyToClipboard } from "@/helpers/clipboardActions";
  import { defaultErrorNotificationMessage } from "@/data/errorMessages";

  @Component({
    components: {
      LinkIcon,
      UIButton,
    },
  })
  export default class ShareUrlButton extends Vue {
    @Prop({ type: String, default: undefined }) readonly routeName?: RouteNames;
    @Prop({ type: String, default: undefined }) readonly id?: string;
    @Prop({ type: Boolean, default: false }) readonly copyCurrentUrl!: boolean;
    @Prop({ type: String, default: "Link copied to clipboard" }) readonly message!: string;
    @Prop({ type: Boolean, default: true }) readonly showIcon!: string;
    @Prop({ type: String, default: 'primary' }) readonly buttonVariant!: string;

    copied: boolean = false;

    get linkStyle(): string {
      return this.copied
        ? "text-gray-600 cursor-default"
        : "text-primary-500 cursor-pointer";
    }

    get buttonText(): string {
      return this.copied
        ? "Link copied to clipboard"
        : "Copy link";
    }

    get link(): string {
      return window.location.href;
    }

    getLocation(routeName: string, id: string): RouteParams<{ id: string }> {
      return {
        name: routeName,
        params: { id },
      };
    }

    async copyLink(): Promise<void> {
      const copied = copyToClipboard(this.link);

      if (!copied) {
        return this.$eventBus.emit(NOTIFICATION, Message.errorMessage(defaultErrorNotificationMessage));
      }

      this.copied = true;
      this.$eventBus.emit(NOTIFICATION, Message.successMessage(this.message));

      setTimeout(() => {
        this.copied = false
      }, 5000);
    }
  }
